var map = {
	"./lang.ar.json": 8339,
	"./lang.en.json": 6563,
	"./lang.es.json": 7652,
	"./lang.eu.json": 202,
	"./lang.pt.json": 364,
	"./lang.ru.json": 1205,
	"./lang.tr.json": 4950,
	"lang/lang.ar.json": 8339,
	"lang/lang.en.json": 6563,
	"lang/lang.es.json": 7652,
	"lang/lang.eu.json": 202,
	"lang/lang.pt.json": 364,
	"lang/lang.ru.json": 1205,
	"lang/lang.tr.json": 4950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2263;